import { AccountProvider, useAccount } from '@/state/account';
import { ImportForm } from '@/components/ImportForm';
import { AccountHeader } from '@/components/AccountHeader';
import { BalanceCard } from '@/components/BalanceCard';
import { SendSolCard } from '@/components/SendSolCard';
import { SendSplCard } from '@/components/SendSplCard';
import { TransactionsCard } from '@/components/TransactionsCard';
import { SignMessageCard } from '@/components/SignMessageCard';
import { Footer } from '@/components/Footer';

function Shell() {
  const { account } = useAccount();
  if (!account) return <ImportForm />;

  return (
    <div className="para:min-h-screen para:bg-muted">
      <main className="para:mx-auto para:flex para:max-w-2xl para:flex-col para:gap-4 para:px-4 para:py-8">
        <header className="para:flex para:flex-col para:items-center para:gap-2 para:text-center">
          <span className="para:inline-flex para:items-center para:rounded-full para:border para:border-border para:bg-card para:px-3 para:py-0.5 para:text-xs para:font-medium para:text-muted-foreground">
            Open Source
          </span>
          <h1 className="para:text-4xl para:font-semibold">Solana Wallet Recovery</h1>
          <p className="para:text-sm para:text-muted-foreground">
            Import a private key exported from Para to view balances and move funds.
          </p>
        </header>
        <AccountHeader />
        <BalanceCard />
        <SendSolCard />
        <SendSplCard />
        <TransactionsCard />
        <SignMessageCard />
        <Footer />
      </main>
    </div>
  );
}

export function App() {
  return (
    <AccountProvider>
      <Shell />
    </AccountProvider>
  );
}

export default App;
